var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[(this.$route.name !=='ExterIndex')?_c('imcHeader',{attrs:{"name":_vm.userName,"env":_vm.env}},[_c('tenant-switch',{attrs:{"tenant-id":_vm.tenantId,"tenant-name":_vm.tenantName,"tenants-list":_vm.tenantsList},on:{"cutTenant":_vm.cutTenant}})],1):_vm._e(),(_vm.tenantReady)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }